import { Layout }               from '@/components/chart/chart.types';
import { ObjectWithStringKeys } from '@/types';

export interface State {
  chartsLayout: Layout[];
  availableFiltersAndFunctions: ObjectWithStringKeys<AvailableFilterOrFunction>;
}

export interface AvailableFilterOption {
  name: string;
  label: string | null;
  isDefault: boolean;
  color?: string | null;
  order?: number | null;
}

export interface AvailableFilterOrFunction {
  label: string | null;
  options?: AvailableFilterOption[];
  isDefault?: boolean;
  color?: string | null;
  order?: number | null;
}

export enum GeneralTabs {
  OUTLET = 'outlet',
  SEGMENTS = 'segments'
}
